/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Permanently_DeleteInputs */

const en_profile_permanently_delete = /** @type {(inputs: Profile_Permanently_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanently delete your account and all of your Listening data.`)
};

const es_profile_permanently_delete = /** @type {(inputs: Profile_Permanently_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina permanentemente tu cuenta y todos tus datos de Listening.`)
};

/**
* | output |
* | --- |
* | "Permanently delete your account and all of your Listening data." |
*
* @param {Profile_Permanently_DeleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_permanently_delete = /** @type {((inputs?: Profile_Permanently_DeleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Permanently_DeleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_permanently_delete(inputs)
	return en_profile_permanently_delete(inputs)
});